import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { viewModelToInput } from "./converter/view-model-to-input";
import { SiteControllerSettingBeds24MasterDataSync_SettingPage_Mutation } from "./mutation";

import type { SiteControllerSettingBeds24FormModel } from "../../../type";

type Props = {
	viewModel: Pick<
		SiteControllerSettingBeds24FormModel["ViewModel"],
		"hotelID" | "beds24AuthenticationApiKey" | "beds24AuthenticationPropKey"
	>; //
};

export const useSyncMasterDataBeds24 = ({
	viewModel: { hotelID, beds24AuthenticationApiKey, beds24AuthenticationPropKey },
}: Props) => {
	const { mutationFunc } = useCustomMutation(SiteControllerSettingBeds24MasterDataSync_SettingPage_Mutation);

	const onSyncMasterData = useCallback(async () => {
		const input = viewModelToInput({
			viewModel: {
				hotelID,
				beds24AuthenticationApiKey,
				beds24AuthenticationPropKey,
			},
		});

		return await mutationFunc({
			variables: {
				input,
			},
		});
	}, [beds24AuthenticationApiKey, beds24AuthenticationPropKey, hotelID, mutationFunc]);

	return { onSyncMasterData };
};
